(() => {
  const section=document.querySelector('[data-collection-reviews]');if(!section)return;
  const list=section.querySelector('[data-collection-review-list]');
  const more=section.querySelector('[data-more-collection-reviews]');
  const error=section.querySelector('[data-collection-review-error]');
  const config=window.Rooted||{};
  const jm=config.judgeme||{};
  if(!jm.shop||!jm.token){section.hidden=true;return;}
  const PAGE_SIZE=25;
  function parseFeed(html,header,page){
    // Parsed inert: DOMParser runs no scripts and fetches no subresources.
    const doc=new DOMParser().parseFromString(String(html||''),'text/html');
    const nodes=[...doc.querySelectorAll('.jdgm-rev')];
    const reviews=[];
    for(const node of nodes){
      const link=node.querySelector('a[href*="/products/"]');
      const productTitle=node.getAttribute('data-product-title')||link?.textContent.trim()||'';
      // Never present an unattributed store review as a review of a candle.
      if(!productTitle)continue;
      const match=(link?.getAttribute('href')||'').match(/\/products\/([a-z0-9-]+)(?:[?#/]|$)/);
      reviews.push({
        author:node.querySelector('[data-is-anonymous=true]')?'Anonymous':node.querySelector('.jdgm-rev__author')?.textContent.trim()||'Anonymous',
        rating:Number(node.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')),
        body:node.querySelector('.jdgm-rev__body')?.textContent.trim()||'',
        date:(node.querySelector('.jdgm-rev__timestamp')?.getAttribute('data-content')||'').slice(0,10),
        verified:node.getAttribute('data-verified-buyer')==='true',
        productTitle,productHandle:match?.[1]||'',
      });
    }
    // The feed carries no pagination markup, so page by the header's review total.
    const total=Number((String(header||'').match(/data-number-of-reviews='(\d+)'/)||[])[1]);
    const nextPage=nodes.length&&Number.isFinite(total)&&(page-1)*PAGE_SIZE+nodes.length<total?page+1:null;
    return {reviews,nextPage};
  }
  async function loadPage(page){
    const query=new URLSearchParams({shop_domain:jm.shop,api_token:jm.token,page:String(page)});
    const response=await fetch(`https://api.judge.me/api/v1/widgets/all_reviews_page?${query}`,{signal:AbortSignal.timeout(10000)});
    if(!response.ok)throw Error();
    const data=await response.json();
    if(typeof data.all_reviews!=='string')throw Error();
    return parseFeed(data.all_reviews,data.all_reviews_header,page);
  }
  const key=r=>[r.productHandle||r.productTitle,r.author,r.date,r.body].map(v=>String(v||'').trim()).join('\n');
  const seen=new Set();
  let nextPage=1,loading=false,failed=false;
  function update(){
    const rows=[...list.children];
    section.setAttribute('aria-busy',String(loading));
    section.querySelector('[data-collection-review-loading]').hidden=!loading;
    section.querySelector('[data-collection-review-empty]').hidden=!!rows.length||loading||failed||!!nextPage;
    more.hidden=loading||(!rows.some(li=>li.hidden)&&!nextPage);
    more.disabled=loading;
    more.textContent=failed?'Try again':'Read more reviews';
  }
  function row(review){
    const li=document.createElement('li');li.className='py-6 first:pt-0';li.dataset.collectionReview='';
    const product=document.createElement('p');product.className='text-[11px] uppercase tracking-wider2 text-accent font-bold mb-3';product.append('Reviewed: ');const title=document.createElement('span');title.dataset.reviewProduct='';title.textContent=review.productTitle;product.append(title);
    const byline=document.createElement('p');byline.className='text-[13px] font-bold tracking-wide';byline.textContent=review.author;
    if(review.verified){const badge=document.createElement('span');badge.className='ml-2 text-[9px] uppercase tracking-wider2 font-bold text-pine bg-sage/20 px-1.5 py-0.5 rounded-sm';badge.textContent='✓ Verified';byline.append(badge);}
    const rating=document.createElement('p');rating.className='text-[11px] text-amber mt-1 mb-2.5';rating.setAttribute('aria-label',`${review.rating} out of 5 stars`);rating.textContent='★'.repeat(review.rating)+'☆'.repeat(5-review.rating);
    if(/^\d{4}-\d{2}-\d{2}$/.test(review.date)){const date=document.createElement('span');date.className='text-smoke ml-2';date.textContent=new Date(review.date+'T00:00:00').toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});rating.append(date);}
    const body=document.createElement('p');body.className='text-[14px] leading-relaxed text-ink/75';body.textContent=review.body;
    li.append(product,byline,rating,body);return li;
  }
  async function revealNext(){
    if(loading)return;
    loading=true;failed=false;error.hidden=true;update();
    try{
      // Continue past pages containing only duplicates, this product's reviews, or reviews below 5 stars.
      while(![...list.children].some(li=>li.hidden)&&nextPage){
        const data=await loadPage(nextPage);if(!Array.isArray(data.reviews))throw Error();
        for(const review of data.reviews){
          // A low rating for one candle must not be repeated on every other product page.
          if(!review.productTitle||review.productHandle===section.dataset.handle||(!review.productHandle&&review.productTitle===section.dataset.productTitle)||!Number.isInteger(review.rating)||review.rating!==5||typeof review.body!=='string'||!review.body.trim())continue;
          const identity=key(review);if(seen.has(identity))continue;seen.add(identity);const li=row(review);li.hidden=true;list.append(li);
        }
        nextPage=Number.isInteger(data.nextPage)&&data.nextPage>nextPage?data.nextPage:null;
      }
      [...list.children].filter(li=>li.hidden).slice(0,4).forEach(li=>li.hidden=false);
    }catch{failed=true;error.textContent=list.children.length?'More reviews could not load. Please try again.':'Customer reviews could not load. Please try again.';error.hidden=false;}
    finally{loading=false;update();}
  }
  more.addEventListener('click',revealNext);
  // Public reads are independent of the switch that prevents form submissions.
  revealNext();
})();
